import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from 'yup';
import { BankIDInputMeta, CorporateNameInputMeta } from "../commonMeta";

export interface ISwitchFormMeta {
  nPriorityBIN: FormInputMeta,
  nPriorityTransactionType: FormInputMeta,
  nPriorityWithOrWithoutPIN: FormInputMeta,
  nPriorityApplicationCard: FormInputMeta,
  iPriorityAssociation: FormInputMeta,
  iPriorityCardTypeNetwork: FormInputMeta,
  iPriorityApplicationCard: FormInputMeta,
  iPriorityTransactionType: FormInputMeta,
  iPriorityWithOrWithoutPIN: FormInputMeta,
  bankID: FormInputMeta,
  corporateName: FormInputMeta,
  schema: any,
}

const SwitchFormMeta = {} as ISwitchFormMeta;

SwitchFormMeta.nPriorityBIN = {
  name: "nPriorityBIN",
  type: "number",
  label: "BIN",
  placeholder: "0",
  validation: yup.string(),
};

SwitchFormMeta.nPriorityApplicationCard = {
  name: "nPriorityApplicationCard",
  type: "number",
  label: "Application Card",
  placeholder: "0",
  validation: yup.string(),
};

SwitchFormMeta.nPriorityTransactionType = {
  name: "nPriorityTransactionType",
  type: "number",
  label: "Transaction Type",
  placeholder: "0",
  validation: yup.string(),
};

SwitchFormMeta.nPriorityWithOrWithoutPIN = {
  name: "nPriorityWiithOrWithoutPIN",
  type: "number",
  label: "With or Without PIN",
  placeholder: "0",
  validation: yup.string(),
};

SwitchFormMeta.iPriorityAssociation = {
  name: "iPriorityAssociation",
  type: "number",
  label: "Association",
  placeholder: "0",
  validation: yup.string(),
};

SwitchFormMeta.iPriorityCardTypeNetwork = {
  name: "iPriorityCardTypeNetwork",
  type: "number",
  label: "Card Type Network",
  placeholder: "0",
  validation: yup.string(),
};

SwitchFormMeta.iPriorityApplicationCard = {
  name: "iPriorityApplicationCard",
  type: "number",
  label: "Application Card",
  placeholder: "0",
  validation: yup.string(),
};

SwitchFormMeta.iPriorityTransactionType = {
  name: "iPriorityTransactionType",
  type: "number",
  label: "Transaction Type",
  placeholder: "0",
  validation: yup.string(),
};

SwitchFormMeta.iPriorityWithOrWithoutPIN = {
  name: "iPriorityWithOrWithoutPIN",
  type: "number",
  label: "With or Without PIN",
  placeholder: "0",
  validation: yup.string(),
};

SwitchFormMeta.bankID = BankIDInputMeta;

SwitchFormMeta.corporateName = CorporateNameInputMeta;

SwitchFormMeta.schema = yup.object().shape(getValidationSchema(SwitchFormMeta));

export default SwitchFormMeta;
